module.exports = __webpack_public_path__ + "img/023-girl-13.9acce744.svg";